// Timeline view over the event log — newest first, optionally filtered by kind.
//
// Adapted from mex (MIT, Copyright (c) 2026 Daksh Jaitly), re-implemented on
// CAI's event log (src/events.ts).

import chalk from "chalk";
import { readEvents, EVENT_KINDS } from "./events.js";
import type { CaiConfig, } from "./types.js";
import type { EventKind, ScaffoldEvent } from "./events.js";

const KIND_COLOR: Record<EventKind, (s: string) => string> = {
  decision: chalk.cyan,
  risk: chalk.red,
  todo: chalk.yellow,
  note: chalk.dim,
};

export interface TimelineOpts {
  kind?: EventKind;
  limit?: number;
  json?: boolean;
}

export function runTimeline(config: CaiConfig, opts: TimelineOpts = {}): ScaffoldEvent[] {
  let events = readEvents(config).slice().reverse(); // newest first
  if (opts.kind) events = events.filter((e) => e.kind === opts.kind);
  if (opts.limit && opts.limit > 0) events = events.slice(0, opts.limit);

  if (opts.json) {
    console.log(JSON.stringify(events, null, 2));
    return events;
  }

  if (events.length === 0) {
    console.log(chalk.dim("No events logged yet. Add one with `cai log <kind> <message>`."));
    console.log(chalk.dim(`Kinds: ${EVENT_KINDS.join(", ")}`));
    return events;
  }

  console.log(chalk.bold("Timeline") + chalk.dim("  (newest first)\n"));
  for (const e of events) {
    const date = e.at.slice(0, 10);
    const tag = KIND_COLOR[e.kind](e.kind.padEnd(8));
    console.log(`  ${chalk.dim(date)}  ${tag}  ${e.message}`);
  }
  return events;
}
